<template>
  <div>
    <div class="modal-header">
      <h2>利用規約</h2>
      <span @click="() => closeModal()">x</span>
    </div>
    <section v-for="(article, idx) in articles" :key="idx">
      <h3>{{ article.title }}</h3>
      <div v-html="article.content" />
    </section>
  </div>
</template>

<script setup>
import getHelp from '@component_path/lib/call_api/master_data/help';
import { onMounted, ref } from 'vue';

const emit = defineEmits(['close']);

const articles = ref(null);

const closeModal = () => {
  emit('close');
};

onMounted(async () => {
  articles.value = await getHelp();
});
</script>
